// extracted by mini-css-extract-plugin
export default {"header":"Header_Customer_header__sbhdC","logo":"Header_Customer_logo__6zlOV","nav":"Header_Customer_nav__qE0Rf","button":"Header_Customer_button__wTzhy"};